import { render, staticRenderFns } from "./PackingPositionConfig.vue?vue&type=template&id=34d2208f"
import script from "./PackingPositionConfig.vue?vue&type=script&lang=js"
export * from "./PackingPositionConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports